<mat-card fxLayoutGap class="p-3 d-flex gap-3">
  <div class="fw-semibold fs-4">{{purchaseTraceId?'Modifica Acquisto':'Nuovo Acquisto'}}</div>
  <p *ngIf="purchaseTraceId">Modifica i dati associati al DEA-ID per la tracciabilità dell'acquisto.</p>
  <p *ngIf="!purchaseTraceId">Compila i dati per ricevere il DEA-ID per la tracciabilità dell'acquisto.</p>
  <form [formGroup]="formGroup" class="d-flex flex-column gap-3">
    <div class="w-100 row m-0 p-0 gap-3">
      <div class="col m-0 p-0">
        <app-dea-label class="mb-2" [label]="'Sede:'"></app-dea-label>
        <mat-radio-group formControlName="headquarter" class="d-flex flex-row gap-4 align-items-start" color="primary">
          <mat-radio-button value="MILANO">Milano</mat-radio-button>
          <mat-radio-button value="GORGONZOLA">Gorgonzola</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="col m-0 p-0 d-flex gap-1">
        <div [ngStyle]="{'width': formGroup.get('category')?.value === 'ALTRO' ? '50%':'100%'}">
          <app-dea-label class="mb-2 w-full" [label]="'Centro di Costo:'"></app-dea-label>
          <select class="form-control dea-form-input" formControlName="category" required>
            <option *ngFor="let category of categoriesOptions;" [value]="category.value">
              {{category.label}}
            </option>
          </select>
        </div>
        <div *ngIf="formGroup.get('category')?.value === 'ALTRO'" style="width: 50%">
          <app-dea-label class="mb-2 w-full" [label]="'Dettagli:'"></app-dea-label>
          <input formControlName="custom_category" type="text" class="form-control dea-form-input text-capitalize"
            maxlength="24" />
        </div>
      </div>
    </div>
    <div class="w-100 d-flex flex-row gap-3">
      <div class="flex-grow-1">
        <app-dea-label class="mb-2" [label]="'Costo Totale:'"></app-dea-label>
        <input formControlName="amount" type="number" class="form-control dea-form-input" required />
      </div>
      <div class="flex-grow-1">
        <app-dea-label class="mb-2" [label]="'Fornitore:'"></app-dea-label>
        <input formControlName="vendor" type="text" class="form-control dea-form-input" required />
      </div>
    </div>
    <div class="w-100">
      <app-dea-label [label]="'Allegato: (Opzionale)'"></app-dea-label>
      <div>
        <input type="file" accept="image/png,image/jpeg,.pdf" class="form-control dea-form-input mb-1"
          placeholder="Seleziona un file" (change)="onFileChange($event)" />
        <div class="fw-lighter fs-055r">Formati accettati: PDF - PNG/JPG/JPEG</div>
      </div>
    </div>
    <div class="w-100">
      <app-dea-label class="mb-2" [label]="'Descrizione: (Opzionale)'"></app-dea-label>
      <textarea formControlName="description" class="form-control dea-form-input" rows="2"
        style="max-height: 80px !important;">
      </textarea>
    </div>
  </form>
  <div *ngIf="error" class="fs-075r text-danger">{{error.message}}</div>
  <div class="m-0 p-0 gap-2" mat-dialog-actions align="end">
    <button class="px-5 py-1" mat-stroked-button (click)="onDismiss()">Annulla</button>
    <button *ngIf="!isPosting" class="px-5 py-1" mat-flat-button color="primary" (click)="onConfirm()">
      Salva
    </button>
    <button *ngIf="isPosting" class="px-5 py-1" mat-flat-button disabled>
      <mat-icon><mat-spinner diameter="18"></mat-spinner></mat-icon> Caricamento
    </button>
  </div>
</mat-card>
